


















import { editFactory } from '@/main/pages';

import { showAlert } from '@/main/utils/notifications';

import { store } from './store/edit';
import { NAME, DUPLICATE_RECORD } from './constants';


export default editFactory(NAME, store).extend({
	methods: {
		async saveClick() {
			const result = await this.save(false);
			if (result?.data?.respId === DUPLICATE_RECORD) {
				await this.showErrorAlert({ message: this.LocalizeChyboveHlasky('DEPARTMENT_UNIQUE') });
				return;
			}
			if (parseInt(result?.data?.respId) > 0) {
				showAlert({
					message: this.LocalizeChyboveHlasky('WMS_DATA_SAVED_SUCCESS'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
					},
				});
			}
		},
	},
});
